var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigmaNetworksDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/left-sidebar/ic network",
    clipPath: "url(#clip0_9146_76146)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic networks"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.279 7.33917L16.054 5.16083L11.2499 7.8625V2.5H8.74987V7.8625L3.9457 5.16083L2.7207 7.33917L7.4507 10L2.7207 12.6608L3.9457 14.8392L8.74987 12.1375V17.5H11.2499V12.1375L16.054 14.8392L17.279 12.6608L12.549 10L17.279 7.33917Z",
    fill: "#BFDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.99967 4.16927C10.9201 4.16927 11.6663 3.42308 11.6663 2.5026C11.6663 1.58213 10.9201 0.835938 9.99967 0.835938C9.0792 0.835938 8.33301 1.58213 8.33301 2.5026C8.33301 3.42308 9.0792 4.16927 9.99967 4.16927Z",
    fill: "#2894FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.6667 7.91927C17.5871 7.91927 18.3333 7.17308 18.3333 6.2526C18.3333 5.33213 17.5871 4.58594 16.6667 4.58594C15.7462 4.58594 15 5.33213 15 6.2526C15 7.17308 15.7462 7.91927 16.6667 7.91927Z",
    fill: "#2894FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.33366 7.91927C4.25413 7.91927 5.00033 7.17308 5.00033 6.2526C5.00033 5.33213 4.25413 4.58594 3.33366 4.58594C2.41318 4.58594 1.66699 5.33213 1.66699 6.2526C1.66699 7.17308 2.41318 7.91927 3.33366 7.91927Z",
    fill: "#2894FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.99967 19.1693C10.9201 19.1693 11.6663 18.4231 11.6663 17.5026C11.6663 16.5821 10.9201 15.8359 9.99967 15.8359C9.0792 15.8359 8.33301 16.5821 8.33301 17.5026C8.33301 18.4231 9.0792 19.1693 9.99967 19.1693Z",
    fill: "#2894FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M3.33366 15.4193C4.25413 15.4193 5.00033 14.6731 5.00033 13.7526C5.00033 12.8321 4.25413 12.0859 3.33366 12.0859C2.41318 12.0859 1.66699 12.8321 1.66699 13.7526C1.66699 14.6731 2.41318 15.4193 3.33366 15.4193Z",
    fill: "#2894FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M16.6667 15.4193C17.5871 15.4193 18.3333 14.6731 18.3333 13.7526C18.3333 12.8321 17.5871 12.0859 16.6667 12.0859C15.7462 12.0859 15 12.8321 15 13.7526C15 14.6731 15.7462 15.4193 16.6667 15.4193Z",
    fill: "#2894FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z",
    fill: "#2894FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9146_76146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaNetworksDefault);
export default __webpack_public_path__ + "static/media/figma-networks-default.d9d3bd6d06c335c7d55520f0792ce8f7.svg";
export { ForwardRef as ReactComponent };